import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import { sendTrackEvent } from '@edx/frontend-platform/analytics';
import { ensureConfig } from '@edx/frontend-platform/config';
import { AppContext } from '@edx/frontend-platform/react';

import messages from './Footer.messages';

ensureConfig([
  'LMS_BASE_URL',
  'LOGO_TRADEMARK_URL',
], 'Footer component');

const EVENT_NAMES = {
  FOOTER_LINK: 'edx.bi.footer.link',
};

class SiteFooter extends React.Component {
  constructor(props) {
    super(props);
    this.externalLinkClickHandler = this.externalLinkClickHandler.bind(this);
  }

  getLocalePrefix(locale) {
    const twoLetterPrefix = locale.substring(0, 2).toLowerCase();
    if (twoLetterPrefix === 'en') {
      return '';
    }
    return `/${twoLetterPrefix}`;
  }

  externalLinkClickHandler(event) {
    const label = event.currentTarget.getAttribute('href');
    const eventName = EVENT_NAMES.FOOTER_LINK;
    const properties = {
      category: 'outbound_link',
      label,
    };
    sendTrackEvent(eventName, properties);
  }

  render() {
    const {
      logo,
      intl,
    } = this.props;
    const { config } = this.context;

    return (
      <footer
        role="contentinfo"
        className="footer border-top py-3 px-4"
      >
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <ul className="footer-menu">
            <li>
              <a
                className="nav-link footer-link"
                href="https://totem-project.org/#about"
              >
                {intl.formatMessage(messages['footer.edxLinks.about'])}
              </a>
            </li>
            <li>
              <a
                className="nav-link footer-link"
                href="https://totem-project.org/#contact"
              >
                {intl.formatMessage(messages['footer.connectLinks.contact'])}
              </a>
            </li>
          </ul>
          <a
            className="d-block"
            href={config.LMS_BASE_URL}
            aria-label={intl.formatMessage(messages['footer.logo.ariaLabel'])}
          >
            <img
              style={{ maxHeight: 45 }}
              src={typeof logo !== 'undefined' ? logo : config.LOGO_TRADEMARK_URL}
              alt={intl.formatMessage(messages['footer.logo.altText'])}
            />
          </a>
        </div>
        <div className="container-fluid d-flex">
          <ul className="legal-links-menu">
            <li>
              <a
                className="btn btn-link"
                href="https://totem-project.org/terms.html"
              >
                {intl.formatMessage(messages['footer.legalLinks.termsOfService'])}
              </a>
            </li>
            <li>
              <a
                className="btn btn-link"
                href="https://totem-project.org/privacy.html"
              >
                {intl.formatMessage(messages['footer.legalLinks.privacyPolicy'])}
              </a>
            </li>
          </ul>
        </div>
      </footer>
    );
  }
}

SiteFooter.contextType = AppContext;

SiteFooter.propTypes = {
  intl: intlShape.isRequired,
  logo: PropTypes.string,
};

SiteFooter.defaultProps = {
  logo: undefined,
};

export default injectIntl(SiteFooter);
export { EVENT_NAMES };
